package it.neckar.lizergy.model.energy.economics

import it.neckar.lizergy.model.financial.economics.YearIndex
import it.neckar.open.unit.other.pct
import kotlin.math.pow

/**
 * Money value that increases every year
 */
data class IncreasingPricePerKWh(
  /**
   * The base value at the start
   */
  val baseValue: PricePerKWh,
  /**
   * The annual increase rate per year
   */
  val increase: @pct Double,
) {

  /**
   * Calculates the resulting value for the given year index
   */
  fun calculateValue(yearIndex: YearIndex): PricePerKWh {
    val factor = (1 + increase).pow(yearIndex.index)
    return baseValue * factor
  }
}
